const URL = {
  SCORM_CREATE_UPLOAD_URL: 'Scorm/CreateUploadUrl',
  SCORM_REPLACE: 'Scorm/Replace',
  SCORM_CREATE_MULTIPART_UPLOAD: 'Scorm/CreateMultipartUpload',
  SCORM_SIGN_UPLOAD_PART: 'Scorm/SignUploadPart',
  SCORM_COMPLETE_UPLOAD: 'Scorm/CompleteUpload',
  SCORM_GET_BY_ID: 'Scorm/GetById',
  SCORM_ENTRY_POINT_URL: 'Scorm/EntryPointUrl',
  SCORM_FILTER: 'Scorm/filter',
  SCORM_DELETE: 'Scorm/Delete',
  SCORM_TRACK: 'Scorm/Track',
  SCORM_GET_RESULT: 'Scorm/GetResult',
}

export default URL
